import React, { useState } from "react";
import { Grid, Typography, InputAdornment } from "@material-ui/core";
import { useAuth } from "../../contexts/AuthContext";
import { Link, useHistory } from "react-router-dom";
import MailOutlineIcon from "@material-ui/icons/MailOutline";
import {
  StyledPaper,
  StyledMainDiv,
  StyledTextField,
  StyledNewUserDiv,
  StyledButtonSignIn,
  StyledDivider,
} from "./registration.css";

export default function Signup() {
  const { signup } = useAuth();
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const history = useHistory();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");

  async function handleSubmit(e) {
    e.preventDefault();
    console.log("e", email, password, confirmPassword);
    if (password !== confirmPassword) {
      return setError("Passwords do not match");
    }

    try {
      setError("");
      setLoading(true);
      await signup(email, password);
      history.push("/login");
    } catch {
      setError("Failed to create an account");
    }

    setLoading(false);
  }

  return (
    <>
      <StyledPaper>
        <StyledMainDiv>
          <Typography variant="h5">Sign Up</Typography>

          <form onSubmit={handleSubmit} autoComplete="off">
            <Grid container>
              <Grid item xs={12}>
                <StyledTextField
                  variant="outlined"
                  type="email"
                  size="small"
                  placeholder="Email"
                  autoComplete="off"
                  error
                  id="email"
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <MailOutlineIcon />
                      </InputAdornment>
                    ),
                    endAdornment: <InputAdornment position="end" />,
                  }}
                  onChange={(e) => {
                    setEmail(e.target.value.trim());
                  }}
                  required
                />
              </Grid>
              <Grid item xs={12}>
                <StyledTextField
                  variant="outlined"
                  type="password"
                  size="small"
                  placeholder="Enter Password"
                  autoComplete="off"
                  error
                  id="password"
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <MailOutlineIcon />
                      </InputAdornment>
                    ),
                    endAdornment: <InputAdornment position="end" />,
                  }}
                  onChange={(e) => {
                    setPassword(e.target.value.trim());
                  }}
                  required
                />
              </Grid>
              <Grid item xs={12}>
                <StyledTextField
                  variant="outlined"
                  type="password"
                  size="small"
                  placeholder="Password Confirmation"
                  autoComplete="off"
                  error
                  id="confirmPassword"
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <MailOutlineIcon />
                      </InputAdornment>
                    ),
                    endAdornment: <InputAdornment position="end" />,
                  }}
                  onChange={(e) => {
                    setConfirmPassword(e.target.value.trim());
                  }}
                  required
                />
              </Grid>
            </Grid>
            <div>
              <StyledButtonSignIn variant="contained" type="submit">
                Sign Up
              </StyledButtonSignIn>
            </div>
          </form>

          <StyledDivider>
            <span>or</span>
          </StyledDivider>

          <StyledNewUserDiv>
            <Typography variant="h6" gutterBottom component="div">
              Already have an account?
              <Link
                onClick={() => {
                  history.push("/");
                }}
              >
                Sign In
              </Link>
            </Typography>
          </StyledNewUserDiv>
        </StyledMainDiv>
      </StyledPaper>
    </>
  );
}
